import React from "react";
import "./LinkButton.scss";
import linkArrow from "../assets/image/home-section-1/link-arrow.svg";

export default function LinkButton({ to, text, className }) {
  return (
    <a href={to} className={`link-button${className ? ` ${className}` : ""}`}>
      {text}
      <img src={linkArrow} alt="link" />
    </a>
  );
}
